import U from '../js/utils';

export default async (elID, value, labelName, requiredYN, oninput, placeholderText, timer) => {
  return new Promise(async (resolve, reject) => {
    try {
      const div = `
        <div id="${elID}Div" class="input-group">
          ${labelName ? `<label for="${elID}">${labelName}</label>` : ''}
          <input type="text" id="${elID}" name="${elID}" val="text" 
          ${requiredYN ? 'required' : ''} 
          placeholder="${placeholderText}"
          value="${value || ''}"
          >
          <span fb-for="${elID}"></span>
        </div>
      `;

      // Create the DOM element from string above
      const element = U.createHTMLElementFromString(div);

      // Find the input element that's within our created div element
      const inputElement = element.querySelector(`#${elID}`);

      // If an oninput handler is provided then add an "input" event listener to the input element
      if (oninput) {
        let debounceTimer = null;
        inputElement.addEventListener('input', () => {
          // If timer is requested (true), use debounce logic
          if (timer) {
            // Clear any existing timer
            if (debounceTimer) {
              clearTimeout(debounceTimer);
            }

            // Set new timer for 800ms
            debounceTimer = setTimeout(() => {
              // Execute function
              thsPage[oninput]();
            }, 900);
          } else {
            // If no timer was requested (false), execute immediately
            thsPage[oninput]();
          }
        });
      }

      resolve(element);
    } catch (error) {
      reject(error);
    }
  });
};
